import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import { useIntl } from 'react-intl';

import type { TFormFieldsMailSubscription } from '@/shared/api/mailSubscription/types';

import { CheckboxInput, Text, Wrapper } from './parts';

interface IProps {
  register: UseFormRegister<TFormFieldsMailSubscription>;
}
const MobileOptIn: React.FC<IProps> = ({ register }) => {
  const { formatMessage } = useIntl();

  const mobileOptIn = formatMessage({ id: 'MobileOptInLabel' });
  return (
    <Wrapper>
      <CheckboxInput
        {...register!('MobileOptIn')}
        className="CheckboxInput"
        type="checkbox"
        id="MobileOptIn_id"
      />
      <Text
        htmlFor="MobileOptIn_id"
        dangerouslySetInnerHTML={{
          __html: mobileOptIn,
        }}
      />
    </Wrapper>
  );
};

export default MobileOptIn;
